import AsyncStorage from "@react-native-async-storage/async-storage";
import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { getStoredState, persistReducer, persistStore } from "redux-persist";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import createSagaMiddleware from "redux-saga";
import middlewares from "../middlewares";
import reducers from "../reducers";

import { rootSaga } from "../sagas";

const getInitialState = (latestState) => {
  return Object.keys(reducers).reduce(
    (acc, curr) => ({
      ...acc,
      [curr]: { ...latestState[curr], ...reducers[curr]?.initialState },
    }),
    {},
  );
};

const sagaMiddleware = createSagaMiddleware();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistConfig = {
  key: "root",
  storage: AsyncStorage,
  whitelist: ["auth", "customer", "attendance"],
  stateReconciler: autoMergeLevel2,
};

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers(reducers),
);
const appReducer = persistedReducer;

const rootReducer = (stateParam, action) => {
  let state = stateParam;
  if (action.type === "RESET_REDUX") {
    state = { ...state, ...getInitialState(state) };
  }
  return appReducer(state, action);
};

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware, ...middlewares)),
);

sagaMiddleware.run(rootSaga);
const persistor = persistStore(store);

const getStateInPersist = () => getStoredState(persistConfig);

export { getStateInPersist, persistor, store };
